import { render } from "./App.vue?vue&type=template&id=496fe3d7"
const script = {}

import "./App.vue?vue&type=style&index=0&id=496fe3d7&lang=css"
script.render = render

export default script